// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// import * as Sentry from '@sentry/browser';
// import * as Integrations from '@sentry/integrations';
import App from './App';
import config from './config';

// Sentry.init({
//   dsn: 'https://4cf86c88e8a547fab5f2eb873e5a945d@sentry.studioavw.nl/14',
//   integrations: [
//     new Integrations.Vue({
//       Vue,
//       attachProps: true,
//     }),
//   ],
// });

Vue.config.productionTip = false;

Vue.prototype.$config = config;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js